import AgRakeBackManage from '@/pages/agentManage/agRakeBackManage'
import CheckDetail from '@/pages/agentManage/agRakeBackManage/CheckDetail'

export default [
  {
    path: '/agRakeBackManage',
    name: 'AgRakeBackManage',
    component: AgRakeBackManage,
    meta: { name: '返佣对账' }
  },
  {
    path: '/agRakeBackManage/checkDetail/:orderId',
    name: 'CheckDetail',
    component: CheckDetail,
    props: true,
    meta: { name: ['返佣对账', '返佣详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/agentManage/agRakeBackManage.js